import { getEnvironmentVariable } from '../../core/helpers'
import { Http } from '../../core/services'

const httpService = new Http({
  baseUrl: `${getEnvironmentVariable('REACT_APP_HTTP_SERVER_URL')}`,
})

export default httpService
